"use client";
import { Image, Title, Text, Button, Flex } from "@mantine/core";
import Moose from "@/app/_media/moose.png";
import QuestionMark from "@/app/_media/question-mark.png";
import NextImage from "next/image";
import PageShell from "./_components/PageShell/PageShell";
import { useRouter } from "next/navigation";

const Page = () => {
  const router = useRouter();
  return (
    <PageShell>
      <Flex
        className="here"
        w="100%"
        h="100%"
        align="center"
        justify="center"
        p="md"
      >
        <Flex direction="column" align="center" gap="md" maw="750px">
          <Flex direction="column" align="center" justify="center">
            <Image
              component={NextImage}
              src={QuestionMark}
              h={100}
              w={100}
              alt="confused moose"
            />
            <Image
              src={Moose}
              component={NextImage}
              h={"128px"}
              w={"128px"}
              alt="confused moose"
            />
          </Flex>
          <Flex align="center" justify="center" direction="column" gap="sm">
            <Title ta="center">Oops, something is not right...</Title>
            <Text c="dimmed" size="lg" ta="center">
              The page you are trying to open does not exist. You may have
              mistyped the address. If you think this is an error contact your
              taxidermist.
            </Text>
            <Button
              size="lg"
              mt="lg"
              onClick={() => {
                router.push("/jobs");
              }}
            >
              Back to Home
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </PageShell>
  );
};

export default Page;
